/**
 * Role-Gated Route Component
 *
 * Allow-list route guard — redirects to /dashboard if the current user's
 * role is not in `allowedRoles`. Generalizes the earlier binary AdminRoute
 * pattern so we can gate pages to arbitrary role sets (e.g. hide Historian
 * from site_viewer but keep it for analyst+).
 *
 * Assumes the tree is already inside <ProtectedRoute> — this guard does not
 * handle unauthenticated users.
 */

import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import type { Role } from '../constants/roles';

interface RoleGatedRouteProps {
  children: React.ReactNode;
  allowedRoles: Role[];
}

export function RoleGatedRoute({ children, allowedRoles }: RoleGatedRouteProps) {
  const role = useAuthStore((state) => state.user?.role) as Role | undefined;

  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
